import './app-config'
import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { BrowserRouter as Router } from 'react-router-dom';
import AppWrapper from './AppWrapper';
// import reportWebVitals from './reportWebVitals';
const Contexts = lazy(() => import('contexts'));
const Loading = lazy(() => import('atoms/Loading/Loading'));
const root = createRoot(document.getElementById('root')! as HTMLElement);
root.render(
	<React.Fragment>
		<Contexts>
			<MantineProvider withGlobalStyles withNormalizeCSS>
				<Router>
					<Suspense fallback={<Loading isLoading />}>
						<ModalsProvider>
							<AppWrapper />
						</ModalsProvider>
					</Suspense>
				</Router>
			</MantineProvider>
		</Contexts>
	</React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
